
import { Component } from 'vue-property-decorator';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import StackedForm from '../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { DepositType } from '@/enums/DepositType';

@Component({
  components: { VFormBuilder },
})
export default class DepositRuleForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get items() {
    return [
      {
        name: 'priority',
        type: InputType.Text,
        label: 'depositRule.form.priority',
        default: 0,
        rules: 'required|integer|greater_than:0',
      },
      {
        name: 'deposit',
        type: InputType.Select,
        label: 'depositRule.form.deposit',
        items: this.depositTypes,
        default: '0.00',
      },
      {
        name: 'startedAt',
        type: InputType.DateTime,
        label: 'depositRule.form.startedAt',
        onlyDate: true,
      },
      {
        name: 'endedAt',
        type: InputType.DateTime,
        label: 'depositRule.form.endedAt',
        onlyDate: true,
      },
    ];
  }

  get depositTypes() {
    const items = Object.values(DepositType);
    const initialValue = (this.initialValues as any)?.deposit?.$numberDecimal?.toString();

    if (initialValue && !items.find((i) => i === initialValue)) {
      items.push(initialValue);
    }

    return items;
  }

  public getData() {
    return { ...this.$refs.form.form };
  }
}
